import { useState } from 'react';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { getRoles, newUser } from './../../../api/api';
import axios from 'axios';
import UserCount from './components/userCount';
import UserNavbar from './components/userNavbar';

const Users = () => {

     const [loading, setLoading] = useState(false)
     const [role, setRole] = useState([])
     const [refresh, setRefresh] = useState(false);
     const [subDomainShow, setSubDomainShow] = useState('')
     const [submit, setSubmit] = useState(true)

     const [name, setName] = useState('')
     const [family, setFamily] = useState('')
     const [mediaName, setMediaName] = useState('')
     const [email, setEmail] = useState('')
     const [phone, setPhone] = useState('')


     const handleName = e => setName(e.target.value)
     const handleFamily = e => setFamily(e.target.value)
     const handleMediaName = e => setMediaName(e.target.value)
     const handleEmail = e => setEmail(e.target.value)
     const handlePhone = e => setPhone(e.target.value)


     const handlesubDomainINput = (e) => {
          e.target.value = e.target.value
               .replace(/[^a-z0-9]/g, '')
               .replace(/(\..*)\./g, '$1')

          setSubDomainShow(e.target.value)
     }

     const handleSubmitForm = async (e) => {
          e.preventDefault()

          try {
               setLoading(true)
               const res = await axios.post(newUser, {
                    firstName: e.target.name.value,
                    lastName: e.target.family.value,
                    mediaName: e.target.mediaName.value,
                    userName: e.target.phone.value,
                    email: e.target.email.value,
                    gender: e.target.gender.value,
                    roleId: e.target.roleId.value,
                    subDomain: subDomainShow ? subDomainShow : null
               });

               setRefresh(true)
               setSubDomainShow('')

               toast.success('کاربر جدید ساخته شد.')
               e.target.name.value = ''
               e.target.family.value = ''
               e.target.mediaName.value = ''
               e.target.phone.value = ''
               e.target.email.value = ''
               e.target.gender.value = 0
               e.target.roleId.value = 1
               e.target.subDomain.value = ''

          } finally {
               setLoading(false)
          }

     }



     useEffect(() => {

          if (name !== '' && family !== '' && phone !== '' && email !== '') {
               setSubmit(false)
          } else {
               setSubmit(true)
          }

     }, [name, family, phone, email]);


     useEffect(() => {

          const roles = async () => {
               const res = await axios.get(getRoles)
               setRole(res.data)
          }
          roles()
     }, []);

     return (
          <>
               <UserNavbar search={false} />
               <div className="contentHolder">
                    <div className="row">
                         <div className="col-md-6">
                              <div className="box_radios">
                                   <div className="headHolder bordered"><p className="title">افزودن کاربر جدید</p></div>

                                   <div className="newCategory" style={{ padding: '20px' }}>
                                        <form onSubmit={handleSubmitForm}>
                                             <p><input type="text" onChange={handleName} name="name" id="name" required placeholder="نام" /></p>
                                             <p><input type="text" onChange={handleFamily} name="family" id="family" required placeholder="نام خانوادگی" /></p>
                                             <p><input type="text" onChange={handleMediaName} name="mediaName" id="mediaName" required placeholder="نام رسانه" /></p>
                                             <p><input type="email" onChange={handleEmail} name="email" id="email" required placeholder="ایمیل" /></p>
                                             <p><input type="text" onChange={handlePhone} name="phone" id="phone" required placeholder="تلفن همراه" /></p>

                                             <p>
                                                  <input type="text" onChange={handlesubDomainINput} name="subDomain" id="subDomain" placeholder="لینک اختصاصی" />
                                                  {subDomainShow !== '' && (<span style={{ fontWeight: 400, textAlign: 'left', display: 'block', direction: 'ltr', letterSpacing: '1px', color: '#797979' }}>sekaans.com/<span style={{ color: '#000' }}>{subDomainShow}</span>/</span>)}
                                             </p>

                                             <p><label style={{ fontSize: '14px' }}>جنسیت : {' '}
                                                  <select name="gender" id="gender" required>
                                                       <option value="1">مرد</option>
                                                       <option value="0">زن</option>
                                                  </select>
                                             </label></p>
                                             <p><label style={{ fontSize: '14px' }}>نقش : {' '}
                                                  <select name="roleId" id="roleId">

                                                       {role && role.map(i => (
                                                            <option key={i.id} value={i.id}>{i.name}</option>
                                                       ))}

                                                  </select>
                                             </label></p>

                                             {submit ? (
                                                  <p><button type="submit" className='disabled'>ساخت کاربر جدید</button></p>

                                             ) : (
                                                  <p><button type="submit" onClick={() => setRefresh(true)}>ساخت کاربر جدید</button></p>
                                             )}
                                        </form>
                                   </div>
                              </div>
                         </div>
                         <div className="col-md-6">
                              <div className="box_radios">
                                   <div className="headHolder bordered"><p className="title">آمار کاربران</p></div>

                                   <div className="categorys" style={{ padding: '20px' }}>
                                        <UserCount refresh={refresh} onRefresh={() => setRefresh(false)} />
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     )
}
export default Users